import React, { Component } from 'react';
import {connect} from "react-redux";
import './Communicate.css';
import LoginCheck from '../../shared/LoginCheck';
import NavBar from '../../shared/NavBar';


import Email from '../../shared/Email';
import Podcast from '../../shared/Podcast';
import Training from '../../shared/Training';

import Notifications from 'react-notify-toast';

class Communicate extends Component {


    constructor(props) {
        super(props);
        this.state = {

        };
        console.log(this.props);

        this.loginCheck();
    }

    loginCheck(){

        let MyCheck = LoginCheck();
        if (MyCheck.loggedIn === true){

            if (this.props.state.loggedIn === false){
                this.props.dispatch(
                    {
                        "type":"SET_USER_DATA",
                        "user": MyCheck.user
                    });
            }

        } else {
            window.location = '#/login';
        }
    }


    render() {

        return (
            <div>
                <NavBar />
                <div className="container">





                    <img class="section-header" src="https://dev.iondeveloper.com/adminimages/communicate.png" />
                    <Notifications />
                    {/*<Alerts />*/}
                    <Podcast />
                    <Email />
                    <Training />
                </div>
            </div>
        );
    }



}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Communicate);


// WEBPACK FOOTER //
// ./src/components/pages/Communicate/Communicate.js